import { render, staticRenderFns } from "./global-history-screen-filters.vue?vue&type=template&id=2918ac1b&scoped=true&"
import script from "./global-history-screen-filters.vue?vue&type=script&lang=js&"
export * from "./global-history-screen-filters.vue?vue&type=script&lang=js&"
import style0 from "./global-history-screen-filters.vue?vue&type=style&index=0&id=2918ac1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918ac1b",
  null
  
)

export default component.exports